import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonIcon from "@mui/icons-material/Person";
import { Avatar, CardActionArea, CardContent, List } from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Api from "../API/api";
import { mobileState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import { dateformat } from "../CommonComponent/CommonFunction";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/HomePage.css";

const { Title } = Typography;

export default function HomePage() {
  const [consultData, setConsultData] = useState<any>();
  const [noticeData, setNoticeData] = useState<any>();
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const WH = useRecoilValue(WHState);
  const MobileState = useRecoilValue(mobileState);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate(); 

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const consult = await Api.get("/Consult/getNotFinynList");
      const notice = await Api.get("/Notice/getShowynList");
      setLoading(false);
      if (consult != undefined || notice != undefined) {
        setConsultData(consult);
        setNoticeData(notice);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      if (div) {
        setdivBoxHeight(div.clientHeight - 29);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="Title">
        HomePage
      </Title>
      <div id="divbox">
        <Grid container spacing={2} className="GridContainer">
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
            <Title level={5} className="FirstSubTitle">
              미완료 리스트
            </Title>
            <List
              sx={{
                height: divboxHeight,
              }}
              className="FirstList"
            >
              {consultData &&
                consultData.map((item: any) => {
                  return (
                    <Card
                      key={item.p_id}
                      className="FirstCard"
                      onClick={() => {
                        navigate("/ConsultDetailPage", {
                          state: { p_id: item.p_id, state: "update" },
                        });
                      }}
                    >
                      <CardActionArea>
                        <CardContent
                          sx={{
                            display: !MobileState ? "flex" : "block",
                          }}
                          className="FirstCardContent"
                        >
                          <div
                            style={{
                              width: !MobileState
                                ? `calc(100% - 180px)`
                                : "100%",
                            }}
                            className="FirstCardContent_FirstDiv"
                          >
                            {!MobileState && (
                              <Avatar className="FirstCardContent_FirstDiv_Avatar">
                                <PersonIcon />
                              </Avatar>
                            )}
                            <Title
                              level={5}
                              className="FirstCardContent_FirstDiv_Title"
                            >
                              {`${item.name}  (${item.sex}/${item.age})-${item.country_name}`}
                            </Title>
                          </div>
                          <div className="FirstCardContent_SecondDiv">
                            <Title
                              level={5}
                              className="FirstCardContent_SecondDiv_Title"
                            >
                              {dateformat(item.insert_time)}
                            </Title>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  );
                })}
            </List>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
            <Title level={5} className="SecondSubTitle">
              공지사항
            </Title>
            <List
              sx={{
                height: divboxHeight,
              }}
              className="SecondList"
            >
              {noticeData &&
                noticeData.map((item: any) => {
                  return (
                    <Card
                      key={item.p_id}
                      className="SecondCard"
                      onClick={() => {
                        navigate("/NoticeDetailPage", {
                          state: { p_id: item.p_id, state: "view" },
                        });
                      }}
                    >
                      <CardActionArea>
                        <CardContent
                          sx={{
                            display: !MobileState ? "flex" : "block",
                          }}
                          className="SecondCardContent"
                        >
                          <div
                            style={{
                              width: !MobileState
                                ? `calc(100% - 180px)`
                                : "100%",
                            }}
                            className="SecondCardContent_FirstDiv"
                          >
                            {!MobileState && (
                              <Avatar className="SecondCardContent_FirstDiv_Avatar">
                                <NotificationsIcon />
                              </Avatar>
                            )}

                            <Title
                              level={5}
                              className="SecondCardContent_FirstDiv_Title"
                            >
                              {item.title}
                            </Title>
                          </div>
                          <div
                            style={{
                              flexDirection: !MobileState ? "column" : "row",
                              width: !MobileState ? "150px" : "100%",
                            }}
                            className="SecondCardContent_SecondDiv"
                          >
                            {!MobileState ? (
                              <>
                                <Title
                                  level={5}
                                  className="SecondCardContent_SecondDiv_Title1"
                                >
                                  작성자 :{item.name}
                                </Title>
                                <Title
                                  level={5}
                                  style={{
                                    margin: "0px",
                                    color: "#919090",
                                  }}
                                  className="SecondCardContent_SecondDiv_Title1"
                                >
                                  {dateformat(item.insert_time)}
                                </Title>
                              </>
                            ) : (
                              <>
                                <Title
                                  level={5}
                                  className="SecondCardContent_SecondDiv_Title2"
                                >
                                  작성자 : {item.name}/
                                  {dateformat(item.insert_time)}
                                </Title>
                              </>
                            )}
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  );
                })}
            </List>
          </Grid>
        </Grid>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
